import {
  SynchronizationSummary,
  synchronizationSummaryFromResponse,
} from '../interfaces/SynchronizationSummary/SynchronizationSummary';
import api, { adminApiPrefix } from './Api';
import {
  ProductMatchingFilter,
  productMatchingFilterToParams,
} from '../interfaces/SynchronizationSummary/ProductMatchingFilter';
import {
  ExternalProductMatchings,
  externalProductMatchingsFromResponse,
} from '../interfaces/SynchronizationSummary/ExternalProductMatching';

const synchronizationSummaryAdminApiPrefix = `${adminApiPrefix}/synchronization-summary`;

export const getSynchronizationSummary =
  async (): Promise<SynchronizationSummary> => {
    const response = await api.get(synchronizationSummaryAdminApiPrefix);

    return synchronizationSummaryFromResponse(response.data.data);
  };

export const getProductMatchingsByPlatform = async (
  filter: ProductMatchingFilter,
): Promise<ExternalProductMatchings> => {
  const response = await api.get(
    `${synchronizationSummaryAdminApiPrefix}/matchings`,
    { params: productMatchingFilterToParams(filter) },
  );

  return externalProductMatchingsFromResponse(response.data);
};
